export enum DocumentActionType {
  FETCH_DOCUMENTS = 'FETCH_DOCUMENTS',
  FETCH_DOCUMENT_TYPES = 'FETCH_DOCUMENT_TYPES'
}
